/* eslint-disable react/display-name */
import React from "react"
import { BLOCKS, MARKS, INLINES } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { useIntl } from "gatsby-plugin-intl"

import * as S from "./styled"
import { useLocale } from "src/common/hooks"

const options = {
  renderNode: {
    [BLOCKS.HEADING_1]: (node, children) => <S.Headline>{children}</S.Headline>,
    [BLOCKS.HEADING_2]: (node, children) => (
      <S.Headline2 as="h2">{children}</S.Headline2>
    ),
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <S.Paragraph>{children}</S.Paragraph>
    ),
    [INLINES.HYPERLINK]: (node, children) => {
      const isInner = node.data.uri.includes("http") === false
      const intl = useIntl()

      if (isInner) {
        const innerUrl = intl.locale === "ru-ru"
          ? `/ru-ru${node.data.uri}`
          : `${node.data.uri}`
        
        return (
          <S.InnerLink to={innerUrl}>
            {children}
          </S.InnerLink>
        )
      }

      return (
        <S.Link href={node.data.uri} target="_blank">
          {children}
        </S.Link>
      )
    },
    [INLINES.ENTRY_HYPERLINK]: (node, children) => {
      const locale = useLocale()
      const { fields, sys } = node.data.target

      const contentType = sys.contentType.sys.contentful_id

      if (contentType === "commonDownloadAssets") {
        const asset = fields.asset[locale]
          ? fields.asset[locale].fields.file[locale].url
          : ""

        const url = `https:${asset}`

        return (
          <S.Link href={url} target="__blank">
            {children}
          </S.Link>
        )
      }

      return children
    },
  },
  renderMark: {
    [MARKS.BOLD]: text => <span>{text}</span>,
  },
}

const Headline = ({ json }) => documentToReactComponents(json, options)

export default Headline
